import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import ruLocale from "date-fns/locale/ru";

import { Badge, Link } from "@lifepay/rc-ui-toolkit";
import HumanReadableDate from "components/utils/HumanReadableDate";
import HintedCurrencyCode from "components/utils/HintedCurrencyCode";

import SMSStatusBadge from "components/processing/transaction/SMSStatusBadge";
import styles from "./Transaction.m.scss";

function Transaction(props) {
  const {
    theme,
    item,
    selectTransaction,
    goToMerchants,
    selectedTransaction,
  } = props;

  const isSelected = selectedTransaction && selectedTransaction.id === item.id;

  const isRelated =
    selectedTransaction &&
    selectedTransaction.transactionId === item.transactionId;

  return (
    <div
      className={classnames(
        theme.wrapper,
        isSelected && theme.active,
        !isSelected && isRelated && theme.related,
        item.isReversal && theme.reversal,
        item.hasReversal && theme.reversed,
        item.status !== "0" && theme.error
      )}
      onClick={() => selectTransaction(item)}
    >
      <div className={classnames(theme.columns)}>
        <div>{item.transactionId || "-"}</div>
        <div>{item.paymentSystem || "-"}</div>
        <div>{item.pan || "-"}</div>
        <div>{item.authCode || "-"}</div>
        <HumanReadableDate
          date={item.date}
          locale={ruLocale}
          NoDate={<div>{"-"}</div>}
        />
        <div className={classnames(theme.amount)}>{item.requestAmount}</div>
        <div className={classnames(theme.currency)}>
          {item.transactionCurrencyCode ? (
            <HintedCurrencyCode code={item.transactionCurrencyCode} />
          ) : (
            "-"
          )}
        </div>
        <div className={classnames(theme.amount)}>{item.fee}</div>
        <div className={classnames(theme.currency)}>
          {item.cardCurrencyCode ? (
            <HintedCurrencyCode code={item.cardCurrencyCode} />
          ) : (
            "-"
          )}
        </div>
        <div>
          {item.merchantName ? (
            <Link
              withRouter={false}
              type={"alt"}
              onClick={() =>
                goToMerchants({
                  search: `merchant-name=${item.merchantName}`,
                  state: {
                    routerStateQuery: {
                      merchantName: item.merchantName,
                    },
                  },
                })
              }
            >
              {item.merchantName}
            </Link>
          ) : (
            "-"
          )}
        </div>
        <div className={classnames(theme.status)}>
          <Badge
            type={
              item.isReversal ? "blue" : item.hasReversal ? "grey" : "green"
            }
          >
            {item.type}
          </Badge>
          {item.hasReversal ? <Badge type={"grey"}>{"отменена"}</Badge> : null}
        </div>
        <SMSStatusBadge status={item.smsStatus} />
      </div>
      {item.status !== "0" && (
        <div className={classnames(theme.error)}>
          <Badge type={"red"}>
            {`Ошибка ${item.status}: ${item.statusName}`}
          </Badge>
        </div>
      )}
    </div>
  );
}

Transaction.displayName = "Transaction";

Transaction.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
  selectTransaction: PropTypes.func,
  goToMerchants: PropTypes.func,
  selectedTransaction: PropTypes.object,
};

Transaction.defaultProps = {};

export default themr("@lifepay/Transaction", styles)(Transaction);



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Transaction/Transaction.js